let ol = require('openlayers');
let jsts = require('jsts/dist/jsts');
let parser = new jsts.io.OL3Parser(undefined, ol);

let AbstractOperation = require('../operations/abstract');
let IsCrossedResult = require('../operations/types/isCrossedResult');


/**
 * Класс IsCrossed
 * @extends AbstractOperation
 */
class IsCrossed extends AbstractOperation {

    /**
     * Создает экземпляр класса IsCrossed
     */
  constructor() {
    super()
  }


    /**
     *
     * @param featureA
     * @param featureB
     * @return {boolean}
     */
    execute(featureA, featureB) {
        let isCrossed = operation(featureA, featureB);

        return new IsCrossedResult({
            result: isCrossed
        })
    }
    }

function operation(featureA, featureB) {
    let geomA = parser.read(featureA.getGeometry());
    let geomB = parser.read(featureB.getGeometry());
    let result = geomA.crosses(geomB);
    return result
}



module.exports = IsCrossed;